import { render, staticRenderFns } from "./Courts.vue?vue&type=template&id=1bf625ba&scoped=true&"
import script from "./Courts.vue?vue&type=script&lang=js&"
export * from "./Courts.vue?vue&type=script&lang=js&"
import style0 from "./Courts.vue?vue&type=style&index=0&id=1bf625ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf625ba",
  null
  
)

export default component.exports